<template>
  <div class="columns is-centered mt-5 px-5">
    <div class="column is-6 container box">
      <div class="image-container">
        <b-image class="my-5" :src="img" style="width: 35%" />
      </div>

      <div class="title has-text-centered mb-6">Inicio de sesión</div>

      <div class="columns is-centered">
        <div class="column is-10">
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(login)">
              <div class="mb-5">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <b-field label="Correo Institucional*">
                    <b-input
                        v-model="email"
                        type="text"
                        placeholder="nombre.apellido"
                        expanded
                    />
                    <p class="control">
                      <b-button style="cursor: default !important;">@usach.cl</b-button>
                    </p>
                  </b-field>
                  <span class="validation-alert">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="mb-5">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <b-field label="Contraseña*">
                    <b-input
                        v-model="password"
                        type="password"
                        placeholder="*******"
                    />
                  </b-field>
                  <span class="validation-alert">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <div class="has-text-right has-text-primary mb-5">
                <b>
                  <a
                      href="https://sso.portal.usach.cl/rescue.php"
                      target="_blank"
                  >¿Olvidaste tu contraseña?
                  </a>
                </b>
              </div>

              <b-button
                  class="is-primary is-fullwidth mb-5"
                  native-type="submit"
              >
                <b>Iniciar sesión</b>
              </b-button>
            </form>
          </ValidationObserver>
          <b-button
              class="is-info is-fullwidth mb-5"
              @click="google_login"
          >
            <b>Ingreso especial</b>
          </b-button>
        </div>
      </div>
    </div>
    <b-loading
        :is-full-page="true"
        v-model="isLoading"
        :can-cancel="false"
    ></b-loading>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      email: "",
      password: "",
      img: "/opc_2_color.png",
      isLoading: false,
    };
  },
  methods: {
    login() {
      this.isLoading = true;
      const correo = this.email + "@usach.cl";
      axios
          .post("/login", {
            email: correo,
            password: this.password,
          })
          .then(res => {
            this.isLoading = false
            localStorage.setItem('user', JSON.stringify(res.data.user));
            window.location.href = "/"
          })
          .catch((error) => {
            console.log(error);
            let error_msg = ""
            // Capturar mensaje de error de la respuesta del backend
            if (error.response) {
              // El servidor respondió con un error
              error_msg = error.response.data.error;
            } else if (error.request) {
              // La solicitud fue hecha pero no hubo respuesta
              error_msg = 'No se pudo conectar con el servidor';
            } else {
              // Algo sucedió al configurar la solicitud
              error_msg = 'Error en la solicitud de inicio de sesión';
            }

            this.$buefy.dialog.alert({
              title: "Error",
              message: error_msg,
              type: "is-danger",
              hasIcon: true,
              onConfirm: () => {
                window.location.href = "/login"
              }
            });

            this.isLoading = false;
          });
    },
    google_login(){
      window.location.href = "/users/sign_in"
    }
  },
};
</script>
<style scoped>
.button {
  border-radius: 10px;
}
.box {
  border-radius: 20px;
}
.input {
  border-radius: 20px;
}
.image-container {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
</style>
